{
    "IncludeintransitioningsequenceLabel": "Automatisch wisselen van rapportweergave",
    "RptdisplintervaltimeLabel": "Automatisch wisselen van rapportweergave",
    "RptdisplintervaltimePlaceholder": "5s",
    "DisplaySwitching_SectionHeader": "Automatisch wisselen van rapportweergave",
    "NAME": "DisplaySwitching"
}